module.exports = __webpack_public_path__ + "img/arrowright.8d41cc98.svg";